import React, { useMemo } from 'react';
import HighchartsReact from 'highcharts-react-official';
import { TeamReadinessAvgGraphGroups } from 'Types/SRITypes';
import EmptyState from 'Components/common/components/EmptyState';
import { useHighchartsModule } from 'Utils/hooks/useHighchartsModule';

type Props = {
  xAxis: string[]
  data: TeamReadinessAvgGraphGroups[]
};

const MultiLineChart: React.FC<Props> = function MultiLineChart(props: Props) {
  const {
    xAxis, data,
  } = props;
  const highcharts = useHighchartsModule();

  const series = data.length ? data : [{}];
  const options = useMemo(() => {
    if (!highcharts) return null;
    return {
      credits: {
        enabled: false,
      },
      chart: {
        zoomType: 'xy',
        height: 350,
        marginTop: 40,
      },
      title: {
        text: '',
      },
      subtitle: {
        text: '',
      },
      plotOptions: {
        line: {
          pointWidth: 16,
        },
      },
      xAxis: [
        {
          categories: xAxis,
        },
      ],
      yAxis: [
        {
          lineWidth: 1,
          tickWidth: 1,
          labels: {
            format: '{value}',
          },
          title: {
            text:
              '<span style="font-size: 14px; font: Roboto; font-weight: 700; color: #000">Score</span>',
            align: 'high',
            offset: 0,
            rotation: 0,
            y: -10,
          },
        },
      ],
      tooltip: {
        shared: false,
        useHTML: true,
      },
      series,
    };
  }, [highcharts, xAxis, series]);

  return (
    <div className="barlinechart">
      {data.length === 0 ? (
        <EmptyState
          msg="No analytics data found"
          detail="Try adjusting your filters to find what you are looking for"
          height="350px"
        />
      )
        : highcharts && options ? (
          <HighchartsReact highcharts={highcharts} options={options} />
        ) : null}
    </div>
  );
};

export default MultiLineChart;
